module.exports = __webpack_public_path__ + "img/p1.07d8afa9.png";